import React from 'react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import './WhatWeDo.css';

/** 순서가 정보다 — 만든 뒤 내보내고, 반응을 보고 고치는 순환. */
const steps = [
  { num: '01', label: '만든다', sub: '작은 단위로 빠르게' },
  { num: '02', label: '내보낸다', sub: '스토어와 웹에 올린다' },
  { num: '03', label: '고친다', sub: '반응을 보고 다시' },
];

const WhatWeDo = () => {
  return (
    <section className="ft-wwd" id="what-we-do">
      <Container>
        <div className="ft-wwd__grid">
          <div className="ft-wwd__copy">
            <span className="ft-wwd__eyebrow">What We Do</span>
            <h2 className="ft-wwd__title">
              만들고, 내보내고,
              <br />
              고칩니다.
            </h2>
            <p className="ft-wwd__body">
              오래 기획하는 대신 작게 만들어 사람들 앞에 내놓습니다. 쓰는 사람의
              반응을 보고 고치거나, 접습니다. 지금 서비스 중인 앱도 이 과정을 거쳐
              나왔습니다.
            </p>
          </div>

          <ol className="ft-wwd__steps">
            {steps.map((s, i) => (
              <motion.li
                key={s.num}
                className="ft-wwd__step"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              >
                <span className="ft-wwd__num" aria-hidden="true">{s.num}</span>
                <strong className="ft-wwd__label">{s.label}</strong>
                <span className="ft-wwd__sub">{s.sub}</span>
              </motion.li>
            ))}
          </ol>
        </div>
      </Container>
    </section>
  );
};

export default WhatWeDo;
